<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات بروشور"
        >
          <b-form
              ref="brochureform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2"
                  md="6"
                  offset-md="3"
              >
                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                          :ref="'refInputEl'"
                          type="file"
                          class="d-none"
                          name="Image"
                          @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                              label="عنوان"
                              label-for="Title"
                              class="mb-0"
                          >
                            <b-form-input
                                id="Title"
                                v-model="Form.Title"
                                name="Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="8">
                    <b-form-group
                        label="زیرنویس"
                        label-for="Subtitle"
                    >
                      <b-form-input
                          v-model="Form.Subtitle"
                          autocomplete="off"
                          name="Subtitle"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="وضعیت"
                        label-for="IsActive"
                    >
                      <v-select
                          v-model="Form.IsActive"
                          :options="enums('IsActive')"
                          dir="rtl"
                          label="text"
                          :clearable="false"
                          :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="توضیحات"
                        label-for="Description"
                    >
                      <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          rows="5"
                          no-resize
                      />
                    </b-form-group>

                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="پیوست"
                        label-for="attachment"
                    >
                    <b-form-file
                        v-model="attachment"
                        placeholder=""
                        :file-name-formatter="formatNames">
                    </b-form-file>
                    <label @click="goToFile" v-if="fileName" style="position: absolute; right: 2rem; z-index: 2; margin-top: 0.438rem; line-height: 1.75; height: 2.714rem !important;">
                      <span class="d-block form-file-text">
                        <span class="badge badge-primary">
                          {{fileName}}
                        </span>
                      </span>
                    </label>
                    </b-form-group>
                  </b-col>
<!--                  <label>-->
<!--                      <span class="d-block form-file-text">-->
<!--                        <span class="badge badge-primary">-->
<!--                          abc.jpg-->
<!--                          {{attachment}}-->
<!--                        </span>-->
<!--                      </span>-->
<!--                  </label>-->
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  name: 'BrochureDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        IsActive: true,
        Subtitle: null,
      },
      loading: false,
      attachment: null,
      fileName: null
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.brochure.add
      if (this.$route.params.id) {
        url = this.$api.brochure.update
      }

      const formData = new FormData(this.$refs.brochureform)
      formData.append('Id', this.Form.Id)
      formData.append('Attachment', this.attachment)
      formData.append('IsActive', this.Form.IsActive)

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.brochure.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
            this.fileName= res.data.Attachment.split('/')[res.data.Attachment.split('/').length -1]
          })
    },
    formatNames(files) {
      this.fileName = files.length === 1 ? files[0].name : null
      // return files.length === 1 ? 'files[0].name' : `${files.length} files selected`
    },
    goToFile(){
      if (res.data.Attachment){

      }
    }
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
